// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
 urlBase: 'https://api-fidelidade.cacaudigital.com/loyalty-gateway-site-new/',
  urlSalesForce:
    'https://www.cacaushow.com.br/on/demandware.store/Sites-CacauShow-Site/',
  urlApiEmailSms: 'https://api-fidelidade.cacaudigital.com/Loyalty.email.API/',
  urlApiLocation: 'https://api.cacaudigital.com:8860/location/v1',
  urlApiAuth: 'https://api.cacaudigital.com:8860/auth/v1',
  cepGateway: 'https://viacep.com.br/ws',
  urlPageLovers: 'https://lovers.cacaushow.com.br/',
  urlSac: 'https://sac.cacaushow.com.br/',
  domain: '.cacaushow.com.br',
};

// export const environment = {
//   production: true,
//   urlBase: 'https://api-fidelidade.cacaudigital.com/Loyalty.gateway.Site/',
//   urlSalesForce:
//     'https://www.cacaushow.com.br/on/demandware.store/Sites-CacauShow-Site/',
//   urlApiEmailSms:
//     'https://apifidelidadeprd.cacaudigital.com/Loyalty.Email.API/',
//   urlApiLocation: 'https://api.cacaudigital.com:8860/location/v1',
//   urlApiAuth: 'https://api.cacaudigital.com:8860/auth/v1',
//   cepGateway: 'https://viacep.com.br/ws',
//   urlPageLovers: 'https://lovers.cacaushow.com.br/'
// };

// export const environment = {
//   production: true,
//   urlBase: 'https://api-fidelidade.cacaudigital.com/Loyalty.gateway.Site/',
//   urlSalesForce:
//     'https://www.cacaushow.com.br/on/demandware.store/Sites-CacauShow-Site/',
//   urlApiEmailSms:
//     'https://apifidelidadeprd.cacaudigital.com/Loyalty.Email.API/',
//   urlApiLocation: 'https://api.cacaudigital.com:8860/location/v1',
//   urlApiAuth: 'https://api.cacaudigital.com:8860/auth/v1',
//   cepGateway: 'https://viacep.com.br/ws',
//   urlPageLovers: 'https://lovers.cacaushow.com.br/'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// export const environment = {
//   production: true,
//   urlBase: 'https://cacaudigital.azure-api.net/Loyalty.Gateway.Site/',
//   urlSalesForce:
//     'https://www.cacaushow.com.br/on/demandware.store/Sites-CacauShow-Site/',
//   urlApiEmailSms:
//     'https://apifidelidadeprd.azurewebsites.net/Loyalty.Email.API/',
//   urlApiLocation: 'https://api.cacaudigital.com:8860/location/v1',
//   urlApiAuth: 'https://api.cacaudigital.com:8860/auth/v1',
//   cepGateway: 'https://viacep.com.br/ws',
//   urlPageLovers: 'https://lovers.cacaushow.com.br/',
// };
